import React, { Component } from "react";

// SVG Components
import filePicture from "../../utils/icons/filePicture";
import fileExcel from "../../utils/icons/fileExcel";
import filePdf from "../../utils/icons/filePdf";
import fileText from "../../utils/icons/fileText";
import fileWord from "../../utils/icons/fileWord";

// CSS
import "../../css/svg-icon.css";

class SvgIcon extends Component {
	typeMap = {
		picture: filePicture,
		excel: fileExcel,
		word: fileWord,
		pdf: filePdf,
		text: fileText
	};

	getType = () => {
		// Return valid type
		if (this.props.type in this.typeMap) return this.props.type;

		// Type not found, return "text" icon by default
		return `text`;
	};

	render() {
		const type = this.getType();

		return <span className={`svg-${type}`}>{this.typeMap[type]}</span>;
	}
}

export default SvgIcon;



// WEBPACK FOOTER //
// ./src/components/utils/SvgIcon.js